import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import RecommendedSection from './components/RecommendedSection';
import RankingSection from './components/RankingSection';
import StatsSection from './components/StatsSection';
import DownloadSection from './components/DownloadSection';
import FaqSection from './components/FaqSection';
import { useEffect } from 'react';

export default function Home() {
  useEffect(() => {
    const jsonLd = {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '亲亲漫画',
      url: window.location.origin,
      description: '提供亲亲漫画安卓APP与iOS手机版下载安装，免费看韩漫、日漫、国漫大全，支持下拉式在线阅读与离线缓存追更。',
      potentialAction: {
        '@type': 'SearchAction',
        target: `${window.location.origin}/search?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(jsonLd);
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <RecommendedSection />
        <RankingSection />
        <StatsSection />
        <DownloadSection />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}